import Handler from './handler';
import type { GetGoodsListConditionSearch, GoodsItem } from '../types';

class SearchHandler extends Handler {
  handle(goodsList: GoodsItem[]): GoodsItem[] {
    const condition = this.condition as GetGoodsListConditionSearch;
    return goodsList?.filter((item) => {
      for (const key of condition.key) {
        for (const value of condition.value) {
          if ((item[key] as string)?.indexOf(value) > -1) {
            return true;
          }
        }
      }
    });
  }
}

export default SearchHandler;
